import { render, staticRenderFns } from "./MaterialRow.vue?vue&type=template&id=c4a34dbc&scoped=true"
import script from "./MaterialRow.vue?vue&type=script&lang=js"
export * from "./MaterialRow.vue?vue&type=script&lang=js"
import style0 from "./MaterialRow.vue?vue&type=style&index=0&id=c4a34dbc&prod&lang=scss"
import style1 from "./MaterialRow.vue?vue&type=style&index=1&id=c4a34dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a34dbc",
  null
  
)

export default component.exports